import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';
import classNames from 'classnames';

import {
  blacklistedManageMenteeStageSelector,
  BLACKLIST_MANAGE_MODAL_STAGES,
  setInputErrors,
  setPersonalisedMenteeEmailersManageModalStage,
} from 'features/communicationManagement';
import PersonalisedMenteeEmailersManageModalRenderer from '../PersonalisedMenteeEmailersManageModalRenderer';
import styles from './PersonalisedMenteeEmailersManageModal.module.scss';

export default function PersonalisedMenteeEmailersManageModal() {
  const dispatch = useDispatch();
  const blacklistedManageMenteeStage = useSelector(
    blacklistedManageMenteeStageSelector
  );

  const onCloseModal = useCallback(() => {
    batch(() => {
      dispatch(setInputErrors(null));
      dispatch(
        setPersonalisedMenteeEmailersManageModalStage(
          BLACKLIST_MANAGE_MODAL_STAGES.close
        )
      );
    });
  }, [dispatch]);

  return (
    <Modal
      className={classNames(styles.manageModalContainer, 'p-xs')}
      isOpen={
        blacklistedManageMenteeStage !== BLACKLIST_MANAGE_MODAL_STAGES.close
      }
      onClose={onCloseModal}
      canClose
      closeOnEscPress={false}
      hasBackdrop
      hasCloseButton={false}
      withoutHeader
      unMountOnClose
    >
      <PersonalisedMenteeEmailersManageModalRenderer />
    </Modal>
  );
}
